// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"042f40ad","401":"33375df3","555":"19335449","692":"329a24d1","741":"e59949da","743":"0c629c0e","806":"3c6cd5db","895":"5f44d504"}[chunkId] + ".chunk.js";
};